module.exports = __webpack_public_path__ + "static/heros2-91691748a939fb0a8d4894a8298913a1.jpeg";